import distance from '@turf/distance';
import { useEffect, useState } from 'react';

export function useAnimatedLocation(targetLat: number, targetLng: number) {
  const [renderedLocation, setRenderedLocation] = useState({
    lat: targetLat,
    lng: targetLng,
  });

  useEffect(() => {
    // Safety check for valid coordinates
    if (typeof targetLat !== 'number' || typeof targetLng !== 'number') return;

    const p1 = [renderedLocation.lng, renderedLocation.lat];
    const p2 = [targetLng, targetLat];

    // Turf distance requires [longitude, latitude]
    const dist = distance(p1, p2, { units: 'meters' });

    // Snap to target if within 2.5 meters
    if (dist < 2.5) {
      if (renderedLocation.lat !== targetLat || renderedLocation.lng !== targetLng) {
        setRenderedLocation({ lat: targetLat, lng: targetLng });
      }
      return;
    }

    // Animation frame loop for easing
    const animation = window.requestAnimationFrame(() => {
      const f = dist < 100_000 ? 0.04 : 1; // Easing factor, teleports if > 100km
      const newLat = renderedLocation.lat + f * (targetLat - renderedLocation.lat);
      const newLng = renderedLocation.lng + f * (targetLng - renderedLocation.lng);

      if (Number.isFinite(newLat) && Number.isFinite(newLng)) {
        setRenderedLocation({ lat: newLat, lng: newLng });
      }
    });

    return () => window.cancelAnimationFrame(animation);
  }, [targetLat, targetLng, renderedLocation]);

  return renderedLocation;
}
